module.exports = __webpack_public_path__ + "img/book-solid-small.e3ccdb04.svg";